var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mall_svg__a",
    x1: 304.34,
    y1: 168.31,
    x2: 840.21,
    y2: 860.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70d48c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M910.92 117c-120.09-5.62-231.58-38.81-340.84-101.51a117.09 117.09 0 00-116.16 0C344.66 78.19 233.17 111.38 113.08 117 49.67 119.92 0 172.31 0 236.23V513a480.87 480.87 0 0077.79 262.29A488.18 488.18 0 00286.3 954.34l88.17 40a333.07 333.07 0 00275.06 0l88.17-40a488.18 488.18 0 00208.51-179.05A480.87 480.87 0 001024 513V236.23c0-63.92-49.67-116.31-113.08-119.23zM764 387.79l-296.5 296.5a34 34 0 01-48.08 0L260 524.79a34 34 0 0148-48.08l135.5 135.46L716 339.71a34 34 0 0148 48.08z",
    fill: "url(#mall_svg__a)"
  })));
}
export default SvgMall;